export default function Tentang() {
  return (
    <div data-testid="page-tentang">
      <div className="pe-container pt-14 pb-16">
        <div className="pe-eyebrow">Tentang</div>
        <h1 className="mt-2 font-display font-bold text-3xl lg:text-4xl">PT Proper Energy Indonesia</h1>
        <p className="mt-5 text-lg text-[color:var(--pe-text-muted)] max-w-3xl">
          Proper Energy berfokus pada PLTS residensial dengan perencanaan engineering yang matang, perangkat berkualitas dengan garansi jelas, dan instalasi rapi yang mudah dirawat.
          Kami mendampingi Bapak/Ibu dari konsultasi hingga pascapasang.
        </p>
        <div className="mt-10 grid md:grid-cols-3 gap-5">
          {[
            { t: "Fondasi engineering", d: "Setiap sistem dirancang untuk kebutuhan hari ini sekaligus ruang pengembangan tahap berikut." },
            { t: "Perangkat berkualitas", d: "Pemilihan panel, inverter, dan baterai sesuai spesifikasi dan garansi yang bisa diverifikasi." },
            { t: "Pendampingan panjang", d: "Monitoring awal, perawatan berkala, dan rencana tumbuh menjadi bagian layanan." },
          ].map((x, i) => (
            <div key={i} className="pe-card">
              <h3 className="font-display font-semibold text-lg">{x.t}</h3>
              <p className="mt-2 text-[color:var(--pe-text-muted)]">{x.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 pe-card">
          <h3 className="font-display font-semibold">Prinsip komunikasi</h3>
          <ul className="mt-3 space-y-2 text-sm text-[color:var(--pe-text-muted)] list-disc pl-5">
            <li>Angka produksi dan penghematan selalu disertai asumsi.</li>
            <li>Tidak menjanjikan "bebas PLN" atau "100% hemat".</li>
            <li>Status data terbuka — jika belum lengkap, kami menandai sebagai estimasi awal.</li>
            <li>Pengembangan sistem terikat batas inverter, panel, baterai, dan kondisi bangunan.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
